import { UI_UNSET, UI_UNSET_VALUE } from '../../types/settings'
import { ISettingsAdapter, ISettingsAdapterArgs, SettingsAdapter } from './settingsAdapter'

export type IStringAdapterArgs<RawType = string | null> = Omit<
  ISettingsAdapterArgs<RawType, string, string | UI_UNSET>,
  'toUiValue' | 'toRawValue'
>

export const StringAdapter = <RawType = string | null>({
  inputName,
  variable,
  type,
  defaultRawValue,
  initialUiValue = UI_UNSET_VALUE,
  skipFormPopulateOnLoad,
  shouldUseRawValue,
  shouldTreatAsUnset,
  schema
}: IStringAdapterArgs<RawType>): ISettingsAdapter<RawType, string, string | UI_UNSET> => {
  const toUiValue = (rawValue: any): string =>
    rawValue === null || rawValue === undefined ? UI_UNSET_VALUE : String(rawValue)

  const toRawValue = (value: string | UI_UNSET): any => value

  return SettingsAdapter<RawType, string, string | UI_UNSET>({
    inputName,
    variable,
    type,
    defaultRawValue,
    initialUiValue,
    toUiValue,
    toRawValue,
    skipFormPopulateOnLoad,
    shouldUseRawValue,
    shouldTreatAsUnset,
    schema
  })
}
